import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ajax-loader',
  templateUrl: './ajax-loader.component.html',
  styleUrls: ['./ajax-loader.component.css']
})
export class AjaxLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
